import { BaseApi } from "../../api";

export interface FitCheckRequest {
  shopLink: string;
}

export interface FitCheckResponse {
  success: boolean;
  message?: string;
  error?: string;
  generatedImagePath?: string;
  description?: string;
}

export class FitCheckApi extends BaseApi {
  async generateFitImage(request: FitCheckRequest): Promise<FitCheckResponse> {
    return this.post<FitCheckResponse>("/protected/fit-check/generate", request);
  }
}
